export default __webpack_public_path__ + "static/gw2-banner-your-inventory-ae68558ed55cfd14d976ea25d59bf2e9.png";